import { useSelector } from 'react-redux';
import getHotelPriceDisplayPreference from '../helpers/selectors/getHotelPriceDisplayPreference';

/*
Rendered prices are frozen into the brochure's editorJSON, so the preference used to build the
document has to match the one stored next to it. saveBrochure/sendBrochure persist the agent's own
selection, so the editor must build with that; a published brochure instead honors the preference
it was saved with.
*/
const useBrochureRateDisplayPreference = ({ brochure, isBrochurePage }) => {
  const agentSelectedPreference = useSelector(getHotelPriceDisplayPreference(true));
  const savedPreference = brochure && brochure.hotelRateDisplayPreference;
  const hasSavedPreference = savedPreference !== undefined && savedPreference !== null;

  if (isBrochurePage && hasSavedPreference) return savedPreference;

  return agentSelectedPreference;
};

export default useBrochureRateDisplayPreference;
